import React, { Component } from "react";
import { connect } from "react-redux";
import { LOGIN_AUTH1_URL, USERNAME, GENERALI_LOGIN_AUTH1_URL, LANGUAGE } from "../utils/Constants";
import { putService } from "../services/RequestServices";
import { getParameterByName } from "../utils/CommonUtils";
import nJwt from "njwt";
import secureRandom from "secure-random";
import { getItem, setItem } from "../utils/storage";
import Logo from "../assets/images/logo.svg";
import "../styles/login.css";
import { notification } from "antd";
import { isGenerali } from "../utils/domain";
import LanguageSelector from "./LanguageSelector";
import { bindActionCreators } from "redux";
import { setLanguage } from "../actions/CommonActions";
import ParticleEffect from "./ParticleEffect";
import { setGoVersion } from "../utils/LocalStore";

const isIE = false || !!document.documentMode;

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      websiteUrl: window.location.href,
      showSuccessMsg: false,
      showFailedMsg: false,
      username: "",
      newVersionMessage: "",
      authAgentWephone: true,
      newAuthUrl: "",
    };

    this.validateCredentials = this.validateCredentials.bind(this);
    this.onInputKeyPress = this.onInputKeyPress.bind(this);
    this.validateName = this.validateName.bind(this);
    this.validatePassword = this.validatePassword.bind(this);
    // this.nameInputChange = this.nameInputChange.bind(this);
    // this.passwordInputChange = this.passwordInputChange.bind(this);
    this.doLoginStep1 = this.doLoginStep1.bind(this);
    this.redirectToApp = this.redirectToApp.bind(this);
    this.loginError = this.loginError.bind(this);
    this.btnloginReset = this.btnloginReset.bind(this);
    this.getJWT = this.getJWT.bind(this);
    this.handleLoginRedirect = this.handleLoginRedirect.bind(this);
  }

  componentDidMount() {
    const invalid = "&loginerror=1";
    const url = window.location.href;
    const urlParams = new URLSearchParams(window.location.search);
    const redirectUri = urlParams.get("redirect");

    const language = getItem(LANGUAGE) || "es";

    if (language !== null) {
      this.props.setLanguage(language);
    }

    if (url.includes(invalid)) {
      const { translations } = this.props;
      const state = { additionalInformation: "Updated the URL with JS" };
      const title = document.title;
      const newUrl = url.replace(invalid, "");

      window.history.replaceState(state, title, newUrl);
      notification.error({
        message: translations.invalid_credentials_message[language],
        placement: "topRight",
      });
    }
    this.handleLoginMessage();
    this.handleAutoLoginRedirect("/webphonego", "autologinredirectwebphone");
    this.handleAutoLoginRedirect("/webagent", "autologinredirectwebagent");

    // *********** REDIRECT LINK ***********
    const origin = window.location.origin;
    const redirectTarget = `${origin}/50/webagent/`;
    let newAuthUrl = `${origin}/auth?redirect=${redirectTarget}`;

    if (redirectUri) {
      try {
        const redirectUrl = new URL(redirectUri);
        const normalizedPath = redirectUrl.pathname.replace(/\/+$/, "");
        console.log(normalizedPath);
        // const validRedirects = ["/50/webagent", "/30/webphone", "/30/webphonego"];
        const allowedDomains = ["go.invoxcontact.io", "test.invoxcontact.io", "staging.invoxcontact.io", "localhost"];
        const isInvoxDomain = allowedDomains.includes(redirectUrl.hostname);

        // const isValidRedirect = isInvoxDomain && validRedirects.includes(normalizedPath);
        const isValidRedirect = isInvoxDomain;
        if (isValidRedirect) {
          let version = "";
          if (normalizedPath.includes("/webphone")) {
            version = "30";
          } else if (normalizedPath.includes("/webagent")) {
            version = "50";
          }

          let newRedirectUri = redirectUri; // fallback

          // Inject version if we have one and it’s not already present
          if (version && !/^\/(30|50)\//.test(redirectUrl.pathname)) {
            newRedirectUri = `${redirectUrl.origin}/${version}${redirectUrl.pathname}${redirectUrl.search}${redirectUrl.hash}`;
          }

          const currentUrl = new URL(window.location);

          if (currentUrl.hostname === "localhost") {
            newAuthUrl = `${currentUrl.protocol}//${currentUrl.hostname}:${currentUrl.port}/auth/?redirect=${newRedirectUri}`;
          } else {
            newAuthUrl = `${window.location.protocol}//${currentUrl.hostname}/auth/?redirect=${newRedirectUri}`;
          }
        }
      } catch (err) {
        console.error("Invalid redirect URI:", redirectUri, err);
      }
    }
    console.log(newAuthUrl);
    this.setState({
      newAuthUrl,
      authAgentWephone: true,
    });
  }
  // *********** END OF REDIRECT LINK ***********

  checkCookie(name) {
    const match = document.cookie.split("; ").find((cookie) => cookie.startsWith(`${name}=`));
    return match ? decodeURIComponent(match.split("=")[1]) : null;
  }

  nameInputChange() {
    setTimeout(this.validateName, 1);
  }

  passwordInputChange() {
    setTimeout(this.validatePassword, 1);
  }

  validateName() {
    let valid = this.nameInput.value;
    if (valid && this.nameInput.classList.contains("error_form")) {
      this.nameInput.classList.remove("error_form");
      this.errorMsgUsername.style.display = "none";
    } else if (!valid && !this.nameInput.classList.contains("error_form")) {
      this.nameInput.classList.add("error_form");
      this.errorMsgUsername.style.display = "block";
    }
    return valid;
  }

  validatePassword() {
    let valid = this.passwordInput.value;
    if (valid && this.passwordInput.classList.contains("error_form")) {
      this.passwordInput.classList.remove("error_form");
      this.errorMsgPwd.style.display = "none";
    } else if (!valid && !this.passwordInput.classList.contains("error_form")) {
      this.passwordInput.classList.add("error_form");
      this.errorMsgPwd.style.display = "block";
    }
    return valid;
  }

  onInputKeyPress(event) {
    if (event.charCode === 13) this.validateCredentials();
  }

  validateCredentials() {
    if (this.state.showFailedMsg) this.setState({ showFailedMsg: false });

    let isNameValid = this.validateName();
    let isPasswordValid = this.validatePassword();

    if (!!isNameValid && !!isPasswordValid) {
      this.loginButton.style.display = "none";
      this.loggingButton.style.display = "block";

      this.doLoginStep1();
    }
  }

  doLoginStep1() {
    let data = {
      username: String(this.nameInput.value).trim(),
      password: String(this.passwordInput.value).trim(),
      permisionlist: [],
    };

    setItem(USERNAME, data.username);

    //get version config-
    // const goVersion = "lgo";

    const url = isGenerali() ? GENERALI_LOGIN_AUTH1_URL : LOGIN_AUTH1_URL;
    putService(url, JSON.stringify(data), this.redirectToApp.bind(this), this.loginError);
  }

  redirectToApp(result) {
    this.btnloginReset();
    this.handleLoginRedirect(result, result.code);
  }

  getJWT(data) {
    let signingKey = secureRandom(256, { type: "Buffer" });
    let jwt = nJwt.create(data, signingKey);
    let token = jwt.compact();

    return token;
  }

  loginError(error) {
    this.setState({ showFailedMsg: true });
    this.btnloginReset();
  }

  handleAutoLoginRedirect(pathFragment, cookieName) {
    const url = window.location.href;
    const redirectURL = getParameterByName("redirect");

    if (url.includes(pathFragment) || (redirectURL && redirectURL.includes(pathFragment))) {
      const cookie = this.checkCookie(cookieName);
      if (cookie) {
        window.location.href = cookie;
      }
    }
  }

  handleLoginMessage() {
    const numintecProd = "https://go.invoxcontact.io/webphone/";
    let redirectUrl = getParameterByName("redirect");
    //console.log(redirectUrl)
    if (redirectUrl && redirectUrl === numintecProd && redirectUrl !== null) {
      let versionDiv = document.getElementById("newVersion");
      //console.log(versionDiv)
      versionDiv.style.display = "block";
    }
  }

  handleInsertAfterDomain(url, str) {
    const ioIndex = url.indexOf(".io/");
    const strIndex = url.indexOf(`/${str}/`);
    console.log("version to be added in url: " + str);
    if (strIndex == -1) {
      if (ioIndex !== -1) {
        // Insert the string after ".io/"
        const newUrl = url.slice(0, ioIndex + 4) + `${str}/` + url.slice(ioIndex + 4);
        console.log("added to url: " + newUrl);
        return newUrl;
      } else {
        // If ".io/" is not found, return the original URL
        return url;
      }
    } else {
      return url;
    }
  }

  handleRemoveAfterDomain(url, substringToRemove) {
    const ioIndex = url.indexOf(".io/");
    const webIndex = url.indexOf("web");
    const substringIndex = url.indexOf(substringToRemove);

    // Check if the string exists in the URL
    if (
      ioIndex !== -1 &&
      webIndex !== -1 &&
      substringIndex !== -1 &&
      substringIndex > ioIndex &&
      substringIndex < webIndex
    ) {
      // Remove the string from the URL
      const newUrl = url.slice(0, ioIndex + 4) + url.slice(substringIndex + substringToRemove.length);
      console.log("removed substring", newUrl);
      return newUrl;
    } else {
      // If the string is not found, return the original URL
      return url;
    }
  }

  findSubstringToRemove(url) {
    const ioIndex = url.indexOf(".io/");
    const webIndex = url.indexOf("web");

    // Check if ".io/" and "web" segments exist in the URL
    if (ioIndex !== -1 && webIndex !== -1 && webIndex > ioIndex) {
      // Extract the substring between ".io/" and "web"
      const substringToRemove = url.substring(ioIndex + 4, webIndex);
      console.log("substring to remove : " + substringToRemove);
      return substringToRemove;
    } else {
      // If the segments are not found or not in the correct order, return null
      return null;
    }
  }

  handleLoginRedirect(result, token) {
    const websiteUrl = window.location.href;
    const numintecTest = "//test.invoxcontact.io";
    const numintecStaging = "//staging.invoxcontact.io";
    const numintecProd = "//go.invoxcontact.io";
    const generaliTest = "//gtest.invoxcontact.io";
    const generaliStaging = "//gstaging.invoxcontact.io";
    const generaliProd = "//ggo.invoxcontact.io";
    const generaliOldProd = "//go-generali.invoxcontact.io";
    const local = "//localhost";
    let goVersion;

    let redirectURL = getParameterByName("redirect");

    if (redirectURL === null || redirectURL === "") {
      if (websiteUrl.includes(numintecTest)) {
        redirectURL = "http://test.invoxcontact.io/profile/";
      } else if (websiteUrl.includes(numintecStaging)) {
        redirectURL = "http://staging.invoxcontact.io/profile/";
      } else if (websiteUrl.includes(numintecProd)) {
        redirectURL = "http://go.invoxcontact.io/profile/";
      } else if (websiteUrl.includes(generaliTest)) {
        redirectURL = "http://gtest.invoxcontact.io/profile/";
      } else if (websiteUrl.includes(generaliStaging)) {
        redirectURL = "http://gstaging.invoxcontact.io/profile/";
      } else if (websiteUrl.includes(generaliProd)) {
        redirectURL = "http://ggo.invoxcontact.io/profile/";
      } else if (websiteUrl.includes(generaliOldProd)) {
        redirectURL = "http://go-generali.invoxcontact.io/autodialer/";
      } else if (
        websiteUrl.includes("localhost") ||
        websiteUrl.includes("https://numintec-login-remastered.netlify.app/")
      ) {
        redirectURL = "http://test.invoxcontact.io/profile/";
      }
    }
    if (redirectURL.includes("/webphonego")) {
      goVersion = result.system_version.webphone;
      let versionWP = result.system_version.webphone;
      let versionWA = result.system_version.webagent;
      setGoVersion(goVersion, versionWP, versionWA);
    }
    if (redirectURL.includes("/webagent")) {
      goVersion = result.system_version.webagent;
      let versionWP = result.system_version.webphone;
      let versionWA = result.system_version.webagent;
      setGoVersion(goVersion, versionWP, versionWA);
    }
    if (goVersion && goVersion !== "go" && !redirectURL.includes(local)) {
      const currentGoVersionIndex = redirectURL.indexOf(goVersion);

      if (currentGoVersionIndex !== -1) {
        // If the URL already contains the correct goVersion, do nothing
        console.log("do nothing version is correct");
        window.location = redirectURL + "?tk=" + token;
      } else {
        console.log("version is not corect");
        let substringToRemove = this.findSubstringToRemove(redirectURL);
        let updatedURL = this.handleRemoveAfterDomain(redirectURL, substringToRemove);
        let redirectToNewGoVersionURL = this.handleInsertAfterDomain(updatedURL, goVersion);
        window.location = redirectToNewGoVersionURL + "?tk=" + token;
      }
    } else {
      let substringToRemove = this.findSubstringToRemove(redirectURL);
      let updatedURL = this.handleRemoveAfterDomain(redirectURL, substringToRemove);
      window.location = updatedURL + "?tk=" + token;
    }
  }

  btnloginReset(disableLogin = false) {
    this.loginButton.style.display = "block";
    this.loginButton.disabled = disableLogin;
    this.loggingButton.style.display = "none";
  }

  render() {
    let { showFailedMsg, showSuccessMsg, username } = this.state;
    let { translations, selectedLanguage } = this.props;
    return (
      <section className={isIE ? "login-page ie_bg" : "login-page login-bg"}>
        <div className="login-page-data">
          <div className="main-logo-div text-center">
            <img src={Logo} alt="Logo" />
          </div>
          <div
            id="newVersion"
            className="alert alert-warning alert-dismissible fade show"
            style={{ display: "none" }}
            role="alert"
          >
            <p
              id="versionMsg"
              className="versionMsg"
              dangerouslySetInnerHTML={{
                __html: translations.newVersionMsg[selectedLanguage],
              }}
            ></p>
          </div>
          <div className="content-center container">
            <div className="row">
              <div className="col-lg-6 col-md-12 ">
                <div className="card-plain">
                  <div className="heading">
                    <h2>{translations.login[selectedLanguage]}</h2>
                  </div>
                  <form className="form login_form">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control text-box"
                        placeholder={translations.userName[selectedLanguage]}
                        ref={(nameInput) => (this.nameInput = nameInput)}
                        onInput={this.validateName}
                        onKeyPress={this.onInputKeyPress}
                        autoFocus
                      />
                      <div className="error_msg_login">
                        <p
                          ref={(errorMsgUsername) => (this.errorMsgUsername = errorMsgUsername)}
                          className="error_msg error_msg_un"
                        >
                          {translations.userNameWarning[selectedLanguage]}
                        </p>
                      </div>
                    </div>
                    <div className="form-group password-block">
                      <input
                        type="password"
                        placeholder={translations.userPassword[selectedLanguage]}
                        className="form-control text-box"
                        ref={(passwordInput) => (this.passwordInput = passwordInput)}
                        onInput={this.validatePassword}
                        onKeyPress={this.onInputKeyPress}
                      />
                      <div className="error_msg_login">
                        <p ref={(errorMsgPwd) => (this.errorMsgPwd = errorMsgPwd)} className="error_msg error_msg_pw">
                          {translations.passwordWarning[selectedLanguage]}
                        </p>
                      </div>
                    </div>
                  </form>
                  <div className="card-plain-footer">
                    <button
                      type="button"
                      className="login-button"
                      ref={(loginButton) => (this.loginButton = loginButton)}
                      onClick={this.validateCredentials}
                    >
                      {" "}
                      {translations.login[selectedLanguage]}{" "}
                    </button>
                    <button
                      type="button"
                      ref={(loggingButton) => (this.loggingButton = loggingButton)}
                      className="logging_button"
                    >
                      <i className="fa fa-spinner fa-spin hidden"></i> {translations.loggingIn[selectedLanguage]}
                    </button>
                    <div id="login_status_msg_div">
                      <p className={showFailedMsg ? "login_failed_msg" : "success_msg"}>
                        {showSuccessMsg && (
                          <span>
                            <span className="icon-ans-calls" style={{ paddingRight: "5px" }}></span>
                            {`${translations.hello[selectedLanguage]} ${username}, ${translations.redirectMsg[selectedLanguage]}`}
                          </span>
                        )}
                        {showFailedMsg && <span>{translations.invalid_credentials_message[selectedLanguage]}</span>}
                      </p>
                    </div>
                  </div>
                  {/* Enlace para usuarios con MFA */}
                  {this.state.authAgentWephone && (
                    <div className="no-mfa-link text-center" style={{ marginTop: "5px" }}>
                      <p style={{ fontSize: "14px" }}>
                        {translations.mfaMsg[selectedLanguage]}
                        <br />
                        <a
                          href={this.state.newAuthUrl}
                          target="_self"
                          rel="noopener noreferrer"
                          style={{ textDecoration: "underline" }}
                        >
                          {translations.mfaLinkText[selectedLanguage]}
                        </a>
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {!isIE && <ParticleEffect />}
        </div>
        <LanguageSelector />
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    translations: state.common.translations,
    selectedLanguage: state.common.language,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      setLanguage,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
